module.exports = __webpack_public_path__ + "img/craneRearLeftOutline.db8b5460.svg";